import React from "react";
import type { PublicLandPriceResponse } from "@/features/publicLandPrice/types";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

export const LandPricePreviousPublicPrices: React.FC<{
  landPrice: PublicLandPriceResponse;
}> = (props) => {
  const { landPrice } = props;

  let previousLandPrices = null;
  if (landPrice.previousPublicPrices) {
    try {
      previousLandPrices = JSON.parse(landPrice.previousPublicPrices) as Record<
        string,
        string
      >;
    } catch (e) {
      console.error(e);
      toast.error("過去の地価情報が取得できませんでした");
      Sentry.captureException(e);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.selected,
      color: theme.palette.common.black,
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  return (
    <Box>
      <Typography variant={"h5"} sx={{ mb: 1 }}>
        過去の地価一覧
      </Typography>
      {previousLandPrices && (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small" aria-label="previous public land price">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">年</StyledTableCell>
                <StyledTableCell align="center">価格 (円/㎡)</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(previousLandPrices).map(([key, value]) => {
                return (
                  <TableRow
                    key={key}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <StyledTableCell
                      component="th"
                      scope="row"
                      align={"center"}
                    >
                      {key}
                    </StyledTableCell>
                    <StyledTableCell align="center">{value}</StyledTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
